<!-- Cards de Totais por Moeda -->
<div class="totais-moeda-section" *ngIf="!loading && cardsTotais.length > 0">
  <div class="totais-moeda-cards">
    <div class="total-moeda-card"
      *ngFor="let card of cardsTotais"
      [ngClass]="'total-' + card.moeda.toLowerCase()"
      [class.total-moeda-card--active]="filtroMoedaSelecionada === card.moeda"
      (click)="onMoedaClick(card.moeda)">
      <div class="total-moeda-icon">
        <img [src]="card.flagUrl" class="flag-icon-small" alt="" />
      </div>
      <div class="total-moeda-info">
        <span class="total-moeda-label">{{ card.label }}</span>
        <span class="total-moeda-valor">{{ formatarValor(card.valor, card.moeda) }}</span>
      </div>
      <i class="pi pi-filter-fill total-moeda-filtro-icon" *ngIf="filtroMoedaSelecionada === card.moeda"></i>
    </div>
  </div>
</div>

<!-- Skeleton dos cards resumo -->
<div class="totais-moeda-section" *ngIf="loading">
  <div class="totais-moeda-cards">
    <p-skeleton *ngFor="let i of [1, 2, 3]" width="100%" height="60px" borderRadius="12px" styleClass="flex-1"></p-skeleton>
  </div>
</div>
